import { mask as maskDirective } from 'vue-the-mask';
import Vue from 'vue';

const directiveValue = (e, b) => (!b.value ? false : maskDirective(e, b));

Vue.directive('mask', directiveValue);
